'use client';

import React from 'react';
import { useTrackingCode } from 'react-hubspot-tracking-code-hook';

import Container from '@src/components/Shared/Container';
import Tick from '@src/components/Icons/Tick';

import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';

import usePreviewContent from '@src/hooks/usePreviewContent';

import { ThankYouPageClientPropTypes } from './ThankYouPage.types';
import constructURL from '@src/utils/constructURL';
import NextLink from '@src/components/Shared/NextLink';
import ArrowForward from '@src/components/Icons/ArrowForward';
import { useRouter } from 'next/navigation';

const ThankYouPageClient: React.FC<ThankYouPageClientPropTypes> = ({ data }) => {
  const router = useRouter();
  const page = usePreviewContent({ content: data?.page });

  const { setPathPageView, setContentType } = useTrackingCode();
  setPathPageView(
    constructURL({
      languageCode: page?.languageCode?.toLowerCase(),
      slug: `/thank-you`,
      baseURL: '',
    })
  );
  setContentType('site-page');

  return (
    <Container className='flex h-screen flex-col items-center justify-center gap-[1.8rem] text-center'>
      <div className='bg-primary flex h-[4.8rem] w-[4.8rem] items-center justify-center rounded-full md:mb-[2rem] md:h-[8rem] md:w-[8rem]'>
        <Tick className='text-body-copy--light p-[0.3rem] md:p-0' />
      </div>
      <h1 className='text-header-copy text-[2.4rem] font-medium md:text-[3.2rem] lg:text-[3.8rem]'>
        {page?.thankYou?.items?.[0]?.title}
      </h1>

      <RenderBodyCopy
        className='text-[1.6rem] leading-[2.4rem] font-light'
        bodyCopy={page?.thankYou?.items?.[0]?.bodyCopy?.json?.content}
      />
      <Container className='mt-[4rem] flex flex-col justify-between gap-[4rem]'>
        {page?.subPages?.items?.map((sub: { pageName: string; slug: string; sys: { id: any } }) => {
          return (
            <p className='text-[1.6rem] lg:text-[1.8rem]' key={`${sub?.sys?.id}-sub-menu`}>
              <NextLink
                className='flex cursor-pointer text-[1.6rem] font-normal lg:text-[1.8rem]'
                target='_self'
                href={sub?.slug}
              >
                {sub?.pageName} <ArrowForward className='ml-[1rem] w-[1.2rem]' />
              </NextLink>
            </p>
          );
        })}

        <button
          onClick={() => router.back()}
          className='common-btn-transition bg-primary hover:bg-primary--v2 flex h-[4.4rem] cursor-pointer items-center justify-center rounded-[0.6rem] px-[2rem] text-center text-[1.6rem] leading-[1.6rem] font-normal tracking-[-0.0304rem] text-[#F6F6F6] transition-colors duration-300 ease-in-out'
          title='Go Back'
        >
          Back
        </button>
      </Container>
    </Container>
  );
};

export default ThankYouPageClient;
